module.exports = __webpack_public_path__ + "static/img/tbType.b55cbfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/haierProduct/images/tbType.jpg
// module id = T92r
// module chunks = 4